import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { TOUR_V2_BOOK_WITH_CONFIDENCE_ITEMS } from 'constants/tours'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import TourV2BookWithConfidenceItem from './TourV2BookWithConfidenceItem'

const BookWithConfidenceContainer = styled.div`
  > * + * {
    margin-top: ${rem(16)};
  }
`

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${rem(24)};

  ${mediaQueryUp.sm} {
    flex-direction: row;
  }
`

function TourV2BookWithConfidence() {
  return (
    <BookWithConfidenceContainer>
      <Heading variant="heading3" align="center">Book with confidence</Heading>
      <ItemsContainer>
        {TOUR_V2_BOOK_WITH_CONFIDENCE_ITEMS.map(item => (
          <TourV2BookWithConfidenceItem
            key={item.title} {...item}
          />
        ))}
      </ItemsContainer>
    </BookWithConfidenceContainer>
  )
}

export default TourV2BookWithConfidence
